<template>
  <div class="patient-overview">
    <div class="header">
      <h3>Overview</h3>
    </div>
    <div class="form">
      <ClinicianPatientFormWrapper />
    </div>
  </div>
</template>

<style>

</style>
<script>
import ClinicianPatientFormWrapper from '@/components/clinician/patients/ClinicianPatientFormWrapper'

export default {
  name: 'ClinicianPatientOverview',
  components: {
    ClinicianPatientFormWrapper
  },
  props: {},
  data: () => {
    return {}
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>
